import * as BlackCard from 'root/src/client/v2/common/components/BlackCard/BlackCard';
import { DropUserInfoWidget } from 'root/src/client/v2/_pages/drops/components/DropUserInfoWidget';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import EarnPointsIcon from 'root/src/client/public/icons/IcEarnPoints';
import { useDropEventListContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventList.context';
import { DropLockStatusWidget, } from 'root/src/client/v2/_pages/drops/components/DropLockStatusWidget';
import defaultPublisherLogo from 'root/src/client/public/default-publisher-logo.png';
import { PlatformIcon, PlatformIconColor } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { GamePlatformIcon, } from 'root/src/client/v2/common/components/Games/components/GamePlatformIcon';
import { PointsApplicationState } from 'root/src/server/modules/points/types/types';
import { BaseTooltip, BaseTooltipContent, } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { colorsNew } from 'root/src/client/web/commonStyles';
export function DropsListItem() {
    return (<BlackCard.Root className="cursor-pointer animate-[slide-up_.3s]">
			<BlackCard.Header className="h-[30%]">
				<DropImage />
			</BlackCard.Header>
			<BlackCard.Separator className="flex flex-initial h-8 justify-around px-2 py-0.5 gap-2 items-center">
				<BrandDetails />
			</BlackCard.Separator>
			<BlackCard.Body className="px-4 pt-6">
				<div className="flex group-hover:hidden flex-col gap-2">
					<DropPreview />
				</div>
				<div className="hidden flex-col group-hover:flex gap-2">
					<DropDetails />
				</div>
			</BlackCard.Body>
			<BlackCard.Footer>
				<div className="hidden group-hover:flex">
					<DropUserInfoWidget />
				</div>
				<div className="flex justify-center items-center group-hover:hidden">
					<ButtonNew className="font-bold">Check Out Dares</ButtonNew>
				</div>
			</BlackCard.Footer>
		</BlackCard.Root>);
}
function DropPointsIcon() {
    const { fill, message } = useDropPointsIcon();
    return (<BaseTooltip delay={0} tooltip={message && (<BaseTooltipContent className="flex flex-col justify-center items-center">
					{message}
				</BaseTooltipContent>)}><EarnPointsIcon fill={fill}/>
		</BaseTooltip>);
}
const useDropPointsIcon = () => {
    const { dropEvent } = useDropEventListContext();
    const { pointsApplicationState, isPointsReservationComplete } = dropEvent.dropUserInfo || {};
    if (isPointsReservationComplete) {
        return {
            fill: colorsNew.primary,
            message: 'Your points reservation was completed!',
        };
    }
    if (pointsApplicationState === PointsApplicationState.APPROVED) {
        return {
            fill: colorsNew.green,
            message: 'Your points application was approved',
        };
    }
    if (pointsApplicationState === PointsApplicationState.REJECTED) {
        return {
            fill: colorsNew.red,
            message: 'Your points application was rejected',
        };
    }
    if (pointsApplicationState === PointsApplicationState.PENDING) {
        return {
            fill: colorsNew.yellow,
            message: 'Your points application is in review',
        };
    }
    return {
        fill: colorsNew.teal,
        message: 'Drop awards points',
    };
};
function PrivateDropWidget() {
    return (<div className="font-mono group-hover:hidden absolute self-center items-center uppercase font-bold rounded bg-primary px-2 py-1 shadow drop-shadow">
			Private
		</div>);
}
function DropImage() {
    var _a;
    const { dropEvent } = useDropEventListContext();
    return (<div className="flex flex-col justify-center items-center flex-initial w-full h-full">
			<img className="overflow-hidden flex flex-initial object-cover object-top self-start group-hover:scale-110 group-hover:-rotate-2 motion-safe:duration-150 brightness-50 w-full h-full" src={dropEvent.image} alt={dropEvent.mnemonicId}/>
			{dropEvent.awardPoints
            && (((_a = dropEvent.dropUserInfo) === null || _a === void 0 ? void 0 : _a.pointsApplicationState) !== PointsApplicationState.REJECTED || dropEvent.isCreatorPointsAllowlisted) && (<div className="absolute top-1 left-2">
					<DropPointsIcon />
				</div>)}
			{dropEvent.lockStatus && (<div className="absolute top-1 right-2">
					<DropLockStatusWidget isLocked={dropEvent.lockStatus.isLocked} description={dropEvent.lockStatus.description}/>
				</div>)}
			{dropEvent.isPrivate && (<PrivateDropWidget />)}
		</div>);
}
function BrandDetails() {
    var _a;
    const { dropEvent } = useDropEventListContext();
    return (<>
			<div className="flex relative items-center">
				<img className="flex flex-initial self-left justify-left max-w-12 max-h-12 rounded-full shadow-[0_0_10px_2px_#00FFED] drop-shadow-[0_0_8px_#00FFED] border-2 border-white" src={(_a = dropEvent.brand.img) !== null && _a !== void 0 ? _a : defaultPublisherLogo.src} alt={dropEvent.brand.name}/>
			</div>
			<span className="flex flex-initial w-full text-xs p-1">{dropEvent.brand.name}</span>
		</>);
}
function DropPreview() {
    const { dropEvent } = useDropEventListContext();
    return (<>
			<p className="font-bold font-mono text-teal">{dropEvent.label}</p>
			<p className="text-xs leading-5 overflow-x-hidden text-ellipsis line-clamp-4">{dropEvent.description}</p>
			<ul role="list" className="flex flex-initial gap-2">
				{dropEvent.platforms.map(platform => (<li key={platform}>
						<div className="flex bg-white p-1 rounded-full">
							<PlatformIcon key={platform} platform={platform} color={PlatformIconColor.Dark} size="xs"/>
						</div>
					</li>))}
			</ul>
		</>);
}
function DropDetails() {
    return (<div className="flex flex-col gap-1">
			<GameGenres />
			<GamePlatforms />
		</div>);
}
function GamePlatforms() {
    const { dropEvent } = useDropEventListContext();
    const { gamePlatforms } = dropEvent;
    if (!(gamePlatforms === null || gamePlatforms === void 0 ? void 0 : gamePlatforms.length)) {
        return null;
    }
    return (<BlackCard.HighlightedSection title="Game platforms" text={(<ul className="flex gap-2">
					{gamePlatforms.map((platform) => {
                return (<GamePlatformIcon size="2x" key={platform} platform={platform}/>);
            })}
				</ul>)}/>);
}
function GameGenres() {
    const { dropEvent } = useDropEventListContext();
    const { genres } = dropEvent;
    if (!genres.length) {
        return null;
    }
    return (<BlackCard.HighlightedSection title="Genres" text={dropEvent.genres.join(', ')}/>);
}
